<template>
	<section class="pt-60" id="applications">
		<div class="container">
			<div class="row mt-4">
				<div id="applications-title" class="col-md-12" contenteditable="false" v-html="quarkRead('applications-title')"></div>
			</div>
			<div class="row">
				<div id="applications-ref1" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref1')"></div>
				<div id="applications-ref2" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref2')"></div>
				<div id="applications-ref3" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref3')"></div>
				<div id="applications-ref4" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref4')"></div>
			</div>

			<div class="row">
				<div class="col-md-3">
					<v-gallery :images="measurements0"></v-gallery>
					<!-- <img class="img-fluid" :src="measurements0[0].url" alt="silicon" @click="showGallery(0)" /> -->
				</div>
				<div class="col-md-3">
					<v-gallery :images="measurements1"></v-gallery>
					<!-- <img class="img-fluid" :src="measurements1[0].url" alt="resolution1" @click="showGallery(1)" />
					<img class="img-fluid" :src="measurements1[1].url" alt="resolution2" @click="showGallery(2)" />-->
				</div>
				<div class="col-md-3">
					<v-gallery :images="measurements2"></v-gallery>
					<!-- <img class="img-fluid" :src="measurements2[0].url" alt="halite" @click="showGallery(3)" />
					<img class="img-fluid" :src="measurements2[1].url" alt="calcite" @click="showGallery(4)" />-->
				</div>
				<div class="col-md-3">
					<v-gallery :images="measurements3"></v-gallery>
					<!-- <img class="img-fluid" :src="measurements3[0].url" @click="showGallery(5)" />
					<img class="img-fluid" :src="measurements3[1].url" @click="showGallery(6)" />-->
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios';
import { Carousel, Slide } from 'vue-carousel';

export default {
	data: () => ({
		baseUrl: '/db-sqlite.php',
		measurements0: [
			{
				title: 'Silicon sample',
				url: 'images/si.jpg'
			}
		],
		measurements1: [
			{
				title: 'Resolution',
				url: 'images/res1.jpg'
			},
			{
				title: 'Resolution',
				url: 'images/res2.jpg'
			}
		],
		measurements2: [
			{
				title: 'Halite sample',
				url: 'images/halite.jpg'
			},
			{
				title: 'Calcite sample',
				url: 'images/calcite.jpg'
			}
		],
		measurements3: [
			{
				title: 'TiO2 ssmple with traces of Rut',
				url: 'images/TiO2.jpg'
			},
			{
				title: 'TiO2 ssmple with traces of Rut',
				url: 'images/TiO2_Rut_Ana_Main_Peaks.jpg'
			}
		],
		images: [],
		movieTitle: '',
		index: null,
		content: []
	}),

	created() {
		console.clear();
		this.images = this.movie2;
		axios
			.get(this.baseUrl + '/quark_table')
			.then(response => {
				this.content = response.data;
				for (var i = 0; i < this.content.length; i++) {
					//this.content[i].content = this.content[i].content.split('img-responsive').join('img-fluid');
					// this.content[i].content = this.content[i].content.replace(/<([^ >]+)[^>]*>/ig, '<$1>');
					// this.content[i].content = this.content[i].content.split('<table>').join('<table class="table  table-bordered">');
				}
				//console.log(this.content[0].content);
			})
			.catch(e => {
				// this.errors.push(e)
				console.log(e);
			});
	},

	methods: {
		quarkRead(section) {
			var content;
			for (var i = 0; i < this.content.length; i++) {
				if (this.content[i].section == section) {
					content = this.content[i].content;
					break;
				}
			}

			return content;
		},

		showGallery(index) {
			this.images = [];
			this.images.push(this.measurements[index]);
			this.index = 0;
		}
	}
};
</script>


.v-gallery .light-gallery a .image-container {
	background-color: white;
}
</style>
